<div style="display:flex;padding-top:300px;font-size:3em;font-weight:bold;justify-content: center;">
  <p>Welcome to Refinitiv News Sentiment Analysis Tool.</p>
</div>
